export default "__VITE_ASSET__UdNB7YCy__"